import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebaseConfig';

/**
 * Route wrapper that requires user to have a teamId
 * Redirects to /team-decision if no team
 */
const TeamRequiredRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [hasTeam, setHasTeam] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user || !user.emailVerified) {
        setLoading(false);
        return;
      }

      try {
        const userRef = doc(db, `users/${user.uid}`);
        const userSnap = await getDoc(userRef);
        
        if (userSnap.exists()) {
          const userData = userSnap.data();
          setHasTeam(!!userData.teamId);
        } else {
          setHasTeam(false);
        }
      } catch (err) {
        console.error('Error checking teamId', err);
        setHasTeam(false);
      } finally {
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, []);

  if (loading) return null; // or a loading spinner
  
  return hasTeam ? children : <Navigate to="/team-decision" replace />;
};

export default TeamRequiredRoute;

